/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateVerificationFlowWithCodeMethod { 
    /**
     * Code from the recovery email  If you want to submit a code, use this field, but make sure to _not_ include the email field, as well.
     */
    code?: string;
    /**
     * Sending the anti-csrf token is only required for browser login flows.
     */
    csrf_token?: string;
    /**
     * The email address to verify  If the email belongs to a valid account, a verifiation email will be sent.  If you want to notify the email address if the account does not exist, see the [notify_unknown_recipients flag](https://www.ory.sh/docs/kratos/self-service/flows/verify-email-account-activation#attempted-verification-notifications)  If a code was already sent, including this field in the payload will invalidate the sent code and re-send a new code.  format: email
     */
    email?: string;
    /**
     * Method is the method that should be used for this verification flow  Allowed values are `link` and `code`. link VerificationStrategyLink code VerificationStrategyCode
     */
    method: UpdateVerificationFlowWithCodeMethod.MethodEnum;
    /**
     * Transient data to pass along to any webhooks
     */
    transient_payload?: object;
}
export namespace UpdateVerificationFlowWithCodeMethod {
    export type MethodEnum = 'link' | 'code';
    export const MethodEnum = {
        Link: 'link' as MethodEnum,
        Code: 'code' as MethodEnum
    };
}


